import React from "react";

import { Box } from "@mui/material";
import { keyframes, styled } from "@mui/system";

interface ICircleProps {
  delay: number;
}

const bounce = keyframes`
  0%, 100% {
    background-color: #F2F2F2;
  }
  33% {
    background-color: #CFBACC;
  }
`

const Circle = styled(Box)(({ delay }: ICircleProps) => ({
  width: "12px",
  height: "12px",
  borderRadius: "50%",
  backgroundColor: "#F2F2F2",
  animation: `${bounce} 1.2s infinite ${delay}ms`,
}))

export const CircleLoader = () => {
  return (
    <Box sx={{ display: "flex", gap: "4px" }}>
      <Circle delay={0} />
      <Circle delay={400} />
      <Circle delay={800} />
    </Box>
  )
}
